/**
 * Canonical site URLs for the General Medicine header (logo, account, hide-list).
 *
 * Build header and layout links from this object instead of string literals so
 * destinations stay in one place.
 */
export const siteRoutes = {
    home: '/',
    login: '/login',
    account: '/account',
    generalAi: {
        chat: '/ai/chat',
        onboarding: '/ai/onboarding',
        healthRecords: '/ai/health-records',
    },
    clinicianHiring: '/clinician-hiring',
    workWithUs: '/work-with-us',
} as const
